import VoiceAssistantWidget from './VoiceAssistantWidget'
export * from './VoiceAssistantWidget'
export default VoiceAssistantWidget
